import { useEffect, useState } from 'react'
import AppDialog, { ModalActions } from '../CustomModal'
import { Label } from '../ui/label'
import { Button } from '../ui/button'

type Channel = 'EMAIL' | 'WHATSAPP'
type Template = 'DEFAULT' | 'SOFT' | 'HARD'

export function SendReminderDialog({
  open,
  onOpenChange,
  onConfirm,
  loading,
  defaultChannel = 'WHATSAPP',
  whatsappOptIn,
}: {
  open: boolean
  onOpenChange: (v: boolean) => void
  onConfirm: (v: { channel: Channel; template: Template }) => void
  loading?: boolean
  defaultChannel?: Channel
  /** Consentement WhatsApp du client ciblé (pour affichage d'un avertissement, non bloquant) */
  whatsappOptIn?: boolean
}) {
  const [channel, setChannel] = useState<Channel>(defaultChannel)
  const [template, setTemplate] = useState<Template>('DEFAULT')

  useEffect(() => {
    if (!open) return
    setChannel(defaultChannel)
  }, [open, defaultChannel])

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title='Envoyer une relance'
      description='Choisissez le canal et le ton du message.'
      footer={
        <ModalActions
          confirmLabel='Envoyer'
          confirmLoading={!!loading}
          onConfirm={() => onConfirm({ channel, template })}
        />
      }
    >
      <div className='px-4 py-2 space-y-3'>
        <div className='grid gap-1.5'>
          <Label>Canal</Label>
          <div className='flex gap-2'>
            <Button
              type='button'
              variant={channel === 'WHATSAPP' ? 'default' : 'outline'}
              onClick={() => setChannel('WHATSAPP')}
            >
              WhatsApp
            </Button>

            <Button
              type='button'
              variant={channel === 'EMAIL' ? 'default' : 'outline'}
              onClick={() => setChannel('EMAIL')}
            >
              Email
            </Button>
          </div>
        </div>

        {channel === 'WHATSAPP' && whatsappOptIn === false ? (
          <div className='rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-300'>
            Ce client n'a pas de consentement WhatsApp enregistré. Vous pouvez
            tout de même envoyer le message.
          </div>
        ) : null}

        <div className='grid gap-1.5'>
          <Label>Modèle</Label>
          <div className='flex gap-2'>
            {(['DEFAULT', 'SOFT', 'HARD'] as const).map((t) => (
              <Button
                key={t}
                type='button'
                variant={template === t ? 'default' : 'outline'}
                onClick={() => setTemplate(t)}
              >
                {t === 'DEFAULT'
                  ? 'Standard'
                  : t === 'SOFT'
                    ? 'Souple'
                    : 'Ferme'}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </AppDialog>
  )
}
